import {TextField} from '@mui/material'
import {TFunction} from 'i18next'
import React from 'react'

type Props = {
  t: TFunction
  value?: number
  onChange: (next: number) => void
}

export const CustomRepetitionEndsAfterRepetitions: React.FC<Props> = ({value, onChange, t}) => {
  if (!value) return null

  return (
    <>
      <TextField
        sx={{
          mx: 2,
          width: 75
        }}
        data-test-id="task-custom-repetition-end-count"
        inputProps={{'data-test-id': 'task-custom-repetition-end-count-input'}}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          const input = parseInt(event.target.value, 10)
          const next = !input || input < 1 ? 1 : input > 99 ? 99 : input

          onChange(next)
        }}
        variant="outlined"
        type="number"
        value={value}
      />
      {t('recurringDialog.repetitions')}
    </>
  )
}
